export const API_INFO_HARMONY = {
  APIS: [
    {
      api: 'atManager#checkAccessToken(number, Permissions)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '申请权限',
      module: 'Permission',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'atManager#requestPermissionsFromUser(Context, Array<Permissions>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '申请权限',
      module: 'Permission',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'notificationManager#requestEnableNotification(UIAbilityContext, AsyncCallback<void>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '申请权限',
      module: 'Permission',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'notificationManager#requestEnableNotification(UIAbilityContext)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '申请权限',
      module: 'Permission',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'notificationManager#isNotificationEnabled(AsyncCallback<boolean>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '申请权限',
      module: 'Permission',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'notificationManager#isNotificationEnabled()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '申请权限',
      module: 'Permission',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'notificationManager#isNotificationEnabledSync()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '申请权限',
      module: 'Permission',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'notificationManager#isDistributedEnabled(AsyncCallback<boolean>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '申请权限',
      module: 'Permission',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'notificationManager#isDistributedEnabled()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '申请权限',
      module: 'Permission',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'Calendar#getEvents(AsyncCallback<Event[]>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历',
      module: 'Calendar',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'Calendar#getEvents(EventFilter, (keyof Event)[], AsyncCallback<Event[]>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历',
      module: 'Calendar',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'Calendar#getEvents(EventFilter?, (keyof Event)[])',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历',
      module: 'Calendar',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'Calendar#getAccount()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历',
      module: 'Calendar',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'CameraInput#open(AsyncCallback<void>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      module: 'Camera',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'CameraInput#open()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      module: 'Camera',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'PhotoOutput#capture(AsyncCallback<void>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      module: 'Camera',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'PhotoOutput#capture()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      module: 'Camera',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'PhotoOutput#capture(PhotoCaptureSetting, AsyncCallback<void>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      module: 'Camera',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'PhotoOutput#capture(PhotoCaptureSetting)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      module: 'Camera',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'VideoOutput#start(AsyncCallback<void>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      module: 'Camera',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'VideoOutput#start()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      module: 'Camera',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'deviceInfo#deviceType',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '设备信息',
      module: 'DeviceInfo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'deviceInfo#manufacture',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '设备信息',
      module: 'DeviceInfo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'deviceInfo#brand',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '设备信息',
      module: 'DeviceInfo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'deviceInfo#marketName',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '设备信息',
      module: 'DeviceInfo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'deviceInfo#productModel',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '设备信息',
      module: 'DeviceInfo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'deviceInfo#hardwareModel',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '设备信息',
      module: 'DeviceInfo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'deviceInfo#ODID',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '设备信息',
      module: 'DeviceInfo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'identifier#getOAID(AsyncCallback<string>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '广告追踪',
      module: 'Identifier',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'identifier#getOAID()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '广告追踪',
      module: 'Identifier',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'asset#preQuery(AssetMap)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '关键资产',
      module: 'KeyAsset',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'asset#preQuerySync(AssetMap)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '关键资产',
      module: 'KeyAsset',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'asset#query(AssetMap)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '关键资产',
      module: 'KeyAsset',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'asset#querySync(AssetMap)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '关键资产',
      module: 'KeyAsset',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'asset#postQuery(AssetMap)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '关键资产',
      module: 'KeyAsset',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'asset#postQuerySync(AssetMap)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '关键资产',
      module: 'KeyAsset',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#on(\'locationChange\', LocationRequest | ContinuousLocationRequest, Callback<Location>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getCurrentLocation(CurrentLocationRequest | SingleLocationRequest, AsyncCallback<Location>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getCurrentLocation(AsyncCallback<Location>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getCurrentLocation(CurrentLocationRequest | SingleLocationRequest?)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getLastLocation()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getAddressesFromLocation(ReverseGeoCodeRequest, AsyncCallback<Array<GeoAddress>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getAddressesFromLocation(ReverseGeoCodeRequest)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getAddressesFromLocationName(GeoCodeRequest, AsyncCallback<Array<GeoAddress>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getAddressesFromLocationName(GeoCodeRequest)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getCountryCode(AsyncCallback<CountryCode>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getCountryCode()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'geoLocationManager#getGeofenceSupportedCoordTypes()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '地理位置',
      module: 'Location',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'audioCapturer#start()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '麦克风',
      module: 'Microphone',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'audioCapturer#start(AsyncCallback<void>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '麦克风',
      module: 'Microphone',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'connection#getNetCapabilities(NetHandle, AsyncCallback<NetCapabilities>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '网络',
      module: 'Network',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'connection#getNetCapabilities(NetHandle)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '网络',
      module: 'Network',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'connection#getNetCapabilitiesSync(NetHandle)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '网络',
      module: 'Network',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'connection#getAddressesByName(string, AsyncCallback<Array<NetAddress>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '网络',
      module: 'Network',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'connection#getAddressesByName(string)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '网络',
      module: 'Network',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'NetHandle#getAddressesByName(string, AsyncCallback<Array<NetAddress>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '网络',
      module: 'Network',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'NetHandle#getAddressesByName(string)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '网络',
      module: 'Network',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'NetHandle#getAddressByName(string, AsyncCallback<NetAddress>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '网络',
      module: 'Network',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'NetHandle#getAddressByName(string)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '网络',
      module: 'Network',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'SystemPasteboard#getData(AsyncCallback<PasteData>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪贴板',
      module: 'Pasteboard',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'SystemPasteboard#getData()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪贴板',
      module: 'Pasteboard',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'SystemPasteboard#getDataSync()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪贴板',
      module: 'Pasteboard',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'SystemPasteboard#getDataSource()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪贴板',
      module: 'Pasteboard',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'SystemPasteboard#getUnifiedData()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪贴板',
      module: 'Pasteboard',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'SystemPasteboard#getUnifiedDataSync()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪贴板',
      module: 'Pasteboard',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'sensor#on(SensorId.ACCELEROMETER, Callback<AccelerometerResponse>, Options?)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '传感器',
      module: 'Sensor',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'sensor#on(SensorId.ACCELEROMETER_UNCALIBRATED, Callback<AccelerometerUncalibratedResponse>, Options?)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '传感器',
      module: 'Sensor',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'sensor#on(SensorId.LINEAR_ACCELEROMETER, Callback<LinearAccelerometerResponse>, Options?)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '传感器',
      module: 'Sensor',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'sensor#on(SensorId.GYROSCOPE, Callback<GyroscopeResponse>, Options?)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '传感器',
      module: 'Sensor',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'sensor#on(SensorId.GYROSCOPE_UNCALIBRATED, Callback<GyroscopeUncalibratedResponse>, Options?)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '传感器',
      module: 'Sensor',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'sensor#once(SensorId.ACCELEROMETER, Callback<AccelerometerResponse>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '传感器',
      module: 'Sensor',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'sensor#once(SensorId.ACCELEROMETER_UNCALIBRATED, Callback<AccelerometerUncalibratedResponse>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '传感器',
      module: 'Sensor',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'sensor#once(SensorId.LINEAR_ACCELEROMETER, Callback<LinearAccelerometerResponse>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '传感器',
      module: 'Sensor',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'sensor#once(SensorId.GYROSCOPE, Callback<GyroscopeResponse>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '传感器',
      module: 'Sensor',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'sensor#once(SensorId.GYROSCOPE_UNCALIBRATED, Callback<GyroscopeUncalibratedResponse>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '传感器',
      module: 'Sensor',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'wifiManager#getScanInfoList()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'Wifi',
      module: 'Wifi',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'wifiManager#getLinkedInfo()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'Wifi',
      module: 'Wifi',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'wifiManager#getLinkedInfo(AsyncCallback<WifiLinkedInfo>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'Wifi',
      module: 'Wifi',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'wifiManager#getIpInfo()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'Wifi',
      module: 'Wifi',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'wifiManager#getIpv6Info()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'Wifi',
      module: 'Wifi',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'wifiManager#getCountryCode()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'Wifi',
      module: 'Wifi',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'wifiManager#startDiscoverDevices()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'Wifi',
      module: 'Wifi',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'AudioViewPicker#select(AudioSelectOptions?)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '音乐和音频',
      module: 'Audio',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'AudioViewPicker#select(AudioSelectOptions, AsyncCallback<Array<string>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '音乐和音频',
      module: 'Audio',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'AudioViewPicker#select(AsyncCallback<Array<string>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '音乐和音频',
      module: 'Audio',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'a2dp#createA2dpSrcProfile()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      module: 'Bluetooth',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'access#enableBluetooth()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      module: 'Bluetooth',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'ble#createGattServer()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      module: 'Bluetooth',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'hfp#createHfpAgProfile()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      module: 'Bluetooth',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'hid#createHidHostProfile()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      module: 'Bluetooth',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'pan#createPanProfile()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      module: 'Bluetooth',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'pbap#createPbapServerProfile()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      module: 'Bluetooth',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'map#createMapMseProfile()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      module: 'Bluetooth',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'bluetoothManager#getBluetoothInfo(Want)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      module: 'Bluetooth',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'DocumentViewPicker#select(DocumentSelectOptions?)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '文件',
      module: 'File',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'DocumentViewPicker#select(DocumentSelectOptions, AsyncCallback<Array<string>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '文件',
      module: 'File',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'DocumentViewPicker#select(AsyncCallback<Array<string>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '文件',
      module: 'File',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'healthStore#readDataSource(DataSourceReadRequest)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '健康',
      module: 'Health',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'healthStore#readData<SamplePoint>(SamplePointReadRequest)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '健康',
      module: 'Health',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'healthStore#readData<ExerciseSequence>(ExerciseSequenceReadRequest)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '健康',
      module: 'Health',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'healthStore#readData<HealthSequence>(HealthSequenceReadRequest)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '健康',
      module: 'Health',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'healthStore#requestAuthorizations(common.UIAbilityContext, AuthorizationRequest)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '健康',
      module: 'Health',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'photoAccessHelper#getAssets(FetchOptions, AsyncCallback<FetchResult<PhotoAsset>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '图片和视频',
      module: 'ImageVideo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'photoAccessHelper#getAssets(FetchOptions)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '图片和视频',
      module: 'ImageVideo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'photoAccessHelper#getBurstAssets(string, FetchOptions)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '图片和视频',
      module: 'ImageVideo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'photoAccessHelper#getAlbums(AlbumType, AlbumSubtype, FetchOptions, AsyncCallback<FetchResult<Album>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '图片和视频',
      module: 'ImageVideo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'photoAccessHelper#getAlbums(AlbumType, AlbumSubtype, AsyncCallback<FetchResult<Album>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '图片和视频',
      module: 'ImageVideo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'photoAccessHelper#getAlbums(AlbumType, AlbumSubtype, FetchOptions?)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '图片和视频',
      module: 'ImageVideo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'PhotoViewPicker#select(PhotoSelectOptions?)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '图片和视频',
      module: 'ImageVideo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'PhotoViewPicker#select(PhotoSelectOptions, AsyncCallback<PhotoSelectResult>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '图片和视频',
      module: 'ImageVideo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'PhotoViewPicker#select(AsyncCallback<PhotoSelectResult>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '图片和视频',
      module: 'ImageVideo',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'contact#selectContacts(AsyncCallback<Array<Contact>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通讯录',
      module: 'Contacts',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'contact#selectContacts()',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通讯录',
      module: 'Contacts',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'contact#selectContacts(ContactSelectionOptions, AsyncCallback<Array<Contact>>)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通讯录',
      module: 'Contacts',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'contact#selectContacts(ContactSelectionOptions)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通讯录',
      module: 'Contacts',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
    {
      api: 'cameraPicker#pick(Context, Array<PickerMediaType>, PickerProfile)',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      module: 'Camera',
      suggestHighFreq: 'higher',
      suggestRule: 'normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: false,
      supportRules: [
        'ban',
        'normal',
      ],
      supportSilence: false,
    },
  ],
  CacheTime: [
    {
      description: '缓存有效时长5分钟',
      time: 'five_minute',
    },
  ],
  General: {
    CacheTime: {
      five_minute: '缓存有效时长5分钟',
    },
    HighFreq: {
      higher: '10秒60次调用认为是高频调用，兜底使用前台规则',
    },
    Scene: {
      back: '后台调用场景',
      before: '隐私协议未同意前调用场景',
    },
    Silence: {
      half_minute: '用户无操作30秒后有调用认为是静默调用，兜底使用前台规则',
    },
    Strategy: {
      normal: '直接调用系统',
      ban: '禁止调用',
    },
    Title: {
      api: '合规全局配置说明： 请参考RightlyAPIScene和RightlyAPIStrategy的定义。 ',
    },
  },
  HighFreq: [
    {
      description: '24小时2次调用认为是高频调用，兜底使用前台规则',
      freq: 'lower',
    },
  ],
  SampleRate: [
    {
      maxReport: 30,
      rate: 0.001,
      scene: 'global',
    },
  ],
  Silence: [
    {
      description: '用户无操作30秒后有调用认为是静默调用，兜底使用前台规则',
      time: 'half_minute',
    },
  ],
};
